import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { MiraklReturnCodeSelect } from './MiraklReturnCodeSelect';
import { getRetailer } from '../../../store/actions/retailer';
import { CymbioSpinner } from '../../common/Spinner';
import { CHANNELS } from '../../../constants/channels';

import styles from './MiraklConfigurationPage.module.scss';

const DisplayPage = {
  SPINNER: 'spinner',
  RETURN_CODE: 'return_code',
};

export function MiraklConfigurationPage() {
  const dispatch = useDispatch();
  const { supplierId, retailerId } = useParams();

  const { missing_retailer_configurations: requiredConfigurations } = useSelector((state) => state.retailer.current);
  const miraklRequiredConfigurations = useSelector((state) => state.channels.requiredConfigurations[CHANNELS.MIRAKL]);

  const displayedPage = useMemo(() => {
    if (miraklRequiredConfigurations?.hasReturnCode) {
      return;
    }
    if (!retailerId) {
      return DisplayPage.SPINNER;
    }
    if (requiredConfigurations.orders?.includes('returnCode')) {
      return DisplayPage.RETURN_CODE;
    }
  }, [miraklRequiredConfigurations, retailerId, requiredConfigurations.orders]);

  useEffect(() => {
    if (!retailerId || !displayedPage) {
      dispatch(getRetailer(retailerId, false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerId, displayedPage]);

  return (
    <div className={styles.wrapper}>
      {displayedPage === DisplayPage.SPINNER && <CymbioSpinner shouldCenterVerticallyInViewport />}
      {displayedPage === DisplayPage.RETURN_CODE && (
        <MiraklReturnCodeSelect supplierId={Number(supplierId)} retailerId={Number(retailerId)} />
      )}
    </div>
  );
}
